import { PRODUCT_TYPES } from '@schuettflix/interfaces';
import { HAZARDOUS_WASTE_PRODUCT_TYPES_SCHEMA } from '@/shared/domain/product/isWasteProduct.ts';

export function isHazardousWasteProduct(productType: PRODUCT_TYPES) {
    return HAZARDOUS_WASTE_PRODUCT_TYPES_SCHEMA.safeParse(productType).success;
}
